var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91719 17.5003H0.289062V5.81675H3.91719V17.5003ZM2.10117 4.223C0.941016 4.223 0 3.26206 0 2.1019C8.3039e-09 1.54464 0.221373 1.0102 0.615419 0.616151C1.00947 0.222105 1.54391 0.000732422 2.10117 0.000732422C2.65844 0.000732422 3.19288 0.222105 3.58692 0.616151C3.98097 1.0102 4.20234 1.54464 4.20234 2.1019C4.20234 3.26206 3.26094 4.223 2.10117 4.223ZM17.4961 17.5003H13.8758V11.8128C13.8758 10.4574 13.8484 8.71909 11.9895 8.71909C10.1031 8.71909 9.81406 10.1917 9.81406 11.7152V17.5003H6.18984V5.81675H9.66953V7.4105H9.72031C10.2047 6.49253 11.3879 5.52378 13.1531 5.52378C16.825 5.52378 17.5 7.94175 17.5 11.0824V17.5003H17.4961Z",
    fill: "#8C7C73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4086c602.svg";
export { ForwardRef as ReactComponent };